"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryFileUploadSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, uploadType, origin }) {
        super({
            result,
            statusCode,
            componentName: 'FILE_UPLOAD_AREA',
            componentSource: 'FILE_UPLOAD_AREA',
            failureDescription: 'NOT_FAILURE_RESULT_EVENT'
        });
        this.action = baseSchema_1.ActionsName.TRY_FILE_UPLOAD;
        this.uploadType = uploadType;
        this.origin = origin;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            uploadType: this.uploadType,
            origin: this.origin
        };
    }
}
exports.default = TryFileUploadSchema;
